import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, catchError, map, of, throwError } from "rxjs";
import { ProdutoVM } from "../../../../model/produto/produtoVM";
import { ProdutoViewModel } from "src/app/api/model/conta/produto/produtoVM";
import { AppConfigurationService } from "../../services/base/appConfiguration.service";
import { DocumentoUploadHelper } from "../helper/documento-upload-helper";
import { EstadosVM } from "src/app/api/model/city/estado/estadoVM";
import { PaisVM } from "src/app/api/model/city/pais/paisVM";

@Injectable({
  providedIn: "root",
})
export class GeoLocalizacaoService {
  constructor(
    private httpClient: HttpClient,
    private appConfigurationService: AppConfigurationService
  ) {}

  ListCountries(): Observable<any> {
    return this.httpClient
      .get<any>(
        `${this.appConfigurationService.apiBaseUrl}/AllLists/ListCountries`
      )
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((err) => {
          return throwError(() => new Error(err || "Erro no servidor"));
        })
      );
  }

  ListStates(): Observable<EstadosVM> {
    return this.httpClient
      .get<EstadosVM>(
        `${this.appConfigurationService.apiBaseUrl}/AllLists/ListStates`
      )
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((err) => {
          return throwError(() => new Error(err || "Erro no servidor"));
        })
      );
  }

  ListCitiesByStates(id: any[]): Observable<any> {
    return this.httpClient
      .post<any>(
        `${this.appConfigurationService.apiBaseUrl}/AllLists/ListCitiesByStates`,
        id
      )
      .pipe(
        map((response) => {
          return response;
        }),

        catchError((err) => {
          return throwError(() => new Error(err));
        })
      );
  }
}
